import { Helmet } from "react-helmet-async";

import { useSearchParams, Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Container from "../../../components/Container";
import PageTitle from "../../../components/PageTitle";
import StepNav from "../../../components/StepNav";
import Button from "../../../components/Button";


import styles from "../index.module.scss";



export default function CompletePage() {
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get('order_id');
    console.log(orderId);
    
    return (
        <>
            <Helmet>
                <title>西部ガス：商品注文画面</title>
                <meta
                    name="description"
                    content="西部ガスグループ公式オンラインショップの注文画面です。"
                />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <div className={styles.orderPage}>
                <AnimatePresence mode="wait">

                        <motion.section
                            key="step3"
                            className={styles.orderPage__confirmSection}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.5, ease: "easeInOut" }}
                        >
                            <PageTitle text="ご注文完了" />
                            <Container>
                                <StepNav step={3} />
                                <p
                                    style={{
                                        fontSize: "3.2rem",
                                        textAlign: "center",
                                        marginBottom: "2rem",
                                    }}
                                    className="noto-sans-jp-bold"
                                >
                                    ご注文いただきありがとうございました。
                                </p>
                                <div
                                    className={`${styles.orderPage__orderId} noto-sans-jp-medium`}
                                >
                                    注文番号：{orderId}
                                </div>
                                <p
                                    style={{
                                        fontSize: "2rem",
                                        lineHeight: "1.8",
                                        margin: "4rem 3rem 6rem",
                                    }}
                                    className="noto-sans-jp-medium"
                                >
                                    ご登録いただいた携帯番号宛にSMSをお送りしました。
                                    <br />
                                    <br />
                                    商品のお届けについて担当者よりご連絡を差し上げますので、もう少々お待ちください。
                                </p>
                                <div>
                                    <Button
                                        variant="white"
                                        className="noto-sans-jp-bold"
                                    >
                                        <Link to="/pr_tableconro"  style={{ display: "flex", flexDirection: "column" }}>
                                            <span>テーブルコンロ</span>
                                            <span>専用サイトに戻る</span>
                                        </Link>
                                    </Button>
                                    <Button
                                        variant="white"
                                        className="noto-sans-jp-bold"
                                    >
                                        <Link to="/pr_fh" style={{ display: "flex", flexDirection: "column" }}>
                                            <span>ガスファンヒーター</span>
                                            <span>専用サイトに戻る</span>
                                        </Link>
                                    </Button>
                                </div>
                            </Container>
                        </motion.section>
                </AnimatePresence>
            </div>
        </>
    );
}
